import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
          准备好开始了吗？
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-lg mx-auto">
          立即加入蓝色导航发布页，体验专业的内容发布与网站导航服务，让您的内容精准触达每一位目标用户。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/zixun-meiti"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-base font-medium transition-all whitespace-nowrap"
          >
            免费开始使用
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 rounded-lg text-base font-medium transition-all whitespace-nowrap"
          >
            联系我们的团队
          </Link>
        </div>
      </div>
    </section>
  );
}